export const getters = {
  getModalViewPaymentMethod: state => state.modalViewPaymentMethod,
  getPaymentMethods: state => state.paymentMethods,
  getPaymentMethod: state => state.paymentMethod
};

export default {};
